import {
  CombinedPurchaseHistory,
  chaseURPurchase,
  combineTransactionTypes,
} from '@tock/shared/utils/patronUtils';
import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';
import { reverse, sortBy } from 'es-toolkit/compat';
import { safeToNumber } from '@tock/coretypes';

const purchaseHistorySelector = createSelector(
  (state: StoreType) => state.patron.purchaseHistory,
  (state: StoreType) => state.patron.transferHistory,
  (state: StoreType) => state.patron.giftCardPurchaseHistory,
  (purchaseHistory, transferHistory, giftCardPurchaseHistory) =>
    combineTransactionTypes(purchaseHistory, transferHistory, giftCardPurchaseHistory.data).filter(
      chaseURPurchase(false)
    )
);

export const purchaseHistorySortedSelector = createSelector(
  purchaseHistorySelector,
  (purchaseHistory) =>
    reverse(
      sortBy(purchaseHistory, (item: CombinedPurchaseHistory) => {
        return safeToNumber(item.purchaseTimestamp);
      })
    )
);

export const purchaseSummariesSelector = (state: StoreType) => state.patron.purchaseSummaries;

export default purchaseHistorySelector;
